import { MenuPosition } from '@nx-frontend/shared/types';
import {
  UiContextMenuSubX as SubX,
  UiContextMenuSubY as SubY,
  UiContextMenuConfigPosition,
} from '@nx-frontend/shared/types';

export interface ContextMenuPosition {
  x: number;
  y: number;
  subX: SubX;
  subY: SubY;
}

export const calculateContextMenuPosition = (
  target: HTMLElement | EventTarget,
  padding: number,
  configPos?: UiContextMenuConfigPosition,
  mousePos?: { x: number; y: number }
): ContextMenuPosition => {
  const rect = (target as HTMLElement).getBoundingClientRect();
  const centerX = window.innerWidth / 2;
  const centerY = window.innerHeight / 2;

  const mouseDeltaX = mousePos ? mousePos.x - rect.left : 0;

  const targetX = rect.left + mouseDeltaX + rect.width / 2;
  const targetY = rect.top + rect.height / 2;

  const isLeft = targetX < centerX;
  const isTop = targetY < centerY;

  let x = isLeft ? rect.left + mouseDeltaX : window.innerWidth - rect.right - (mousePos ? rect.right - mousePos.x : 0);
  let y = isTop
    ? rect.top + rect.height + window.scrollY + padding
    : window.innerHeight - rect.bottom - window.scrollY + padding;
  if (configPos === UiContextMenuConfigPosition.TOP_RIGHT) {
    x = rect.right - (mousePos ? rect.right - mousePos.x : 0);
    y = rect.top;
  }
  if (configPos === UiContextMenuConfigPosition.TOP_LEFT) {
    x = rect.left - (mousePos ? rect.left - mousePos.x : 0);
    y = rect.top;
  }
  if (configPos === UiContextMenuConfigPosition.BOTTOM_RIGHT) {
    x = rect.right - (mousePos ? rect.right - mousePos.x : 0);
  }
  if (configPos === UiContextMenuConfigPosition.BOTTOM) {
    x = targetX - 90;
  }
  if (configPos === UiContextMenuConfigPosition.RIGHT) {
    y = targetY - 140;
    x = targetY - 50;
  }
  const subX = isTop ? SubX.TOP : SubX.BOTTOM;
  const subY = isLeft ? SubY.LEFT : SubY.RIGHT;

  return { x, y, subX, subY };
};

export const getContextSubMenuPosition = (subX: SubX, subY: SubY) => {
  return [subX === SubX.TOP ? '-top-[4px]' : '-bottom-[4px]', subY === SubY.LEFT ? 'left-full' : 'right-full'].join(
    ' '
  );
};

export type PositionMapInterface = {
  [key: string]: MenuPosition;
};

export const getContextMenuPosition = (x: number, y: number, subX: SubX, subY: SubY): MenuPosition => {
  const positionMap: PositionMapInterface = {
    topleft: { top: `${y}px`, left: `${x}px` },
    topright: { top: `${y}px`, right: `${x}px` },
    bottomleft: { bottom: `${y}px`, left: `${x}px` },
    bottomright: { bottom: `${y}px`, right: `${x}px` },
  };

  const key = `${subX}${subY}`.toLowerCase();
  return positionMap[key] || { top: `${y}px`, left: `${x}px` };
};

export const getContextMenuPositionByTarget = (
  target: HTMLElement | EventTarget,
  padding = 4,
  configPos?: UiContextMenuConfigPosition
): MenuPosition => {
  const { x, y, subX, subY } = calculateContextMenuPosition(target, padding, configPos);
  return getContextMenuPosition(x, y, subX, subY);
};
